import React from "react";
import { Card, Grid } from "@mui/material";
import CardBody from "../../../../components/Card/CardBody";
import allergenen from "../../../../variables/allergenen";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import { useFormContext } from "react-hook-form";

function AlohaAllermap() {
  const { menukaartVestigingId } = useFormContext();
  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <Grid container spacing={1} style={{ maxWidth: 1400 }}>
            {Object.keys(allergenen).map((item) => {
              let dbkey = "allergeenmap__" + item;

              return (
                <FormAsyncTC
                  async={{
                    url:
                      "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                      menukaartVestigingId,
                    searchField: "naam",
                  }}
                  key={dbkey + menukaartVestigingId}
                  name={dbkey}
                  nullable={true}
                  tDefault={allergenen[item].label}
                  tKey={"vestigingen.form.apiaccounts.label.alohaallermap." + item}
                />
              );
            })}
          </Grid>
        </CardBody>
      </Card>
    </div>
  );
}

export default AlohaAllermap;
